import { createFileRoute } from "@tanstack/react-router";

import ConnectSearch from "@/pages/connect/search";

export const Route = createFileRoute("/connect/search")({
  component: ConnectSearchPage,
  head: () => ({ meta: [{ title: "Connect: Search" }] }),
});

function ConnectSearchPage() {
  return <ConnectSearch />;
}
